var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[(_vm.rendered || index < _vm.renderedItemsCount)?_vm._t("default",null,{"item":item,"index":index}):_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }